import { createAxiosClient } from "@/shared/axios/axios";
import { handleAxiosError } from "@/shared/helper/handleAxiosError.helper";
import type { CustomerEmailUpdateRequest } from "@/shared/generated/ExpHubApi";

export const serializeDataForUpdateInvoiceEmail = (email: string) => {
  return {
    email,
    kind: "INVOICE" as const,
  };
};

export const updateInvoiceEmail = async ({
  userId,
  customerId,
  data,
}: {
  userId: string;
  customerId: string;
  data: CustomerEmailUpdateRequest;
}) => {
  try {
    const client = await createAxiosClient();
    await client.patch(`/users/${userId}/accounts/${customerId}/emails`, data);
  } catch (error) {
    throw handleAxiosError(error);
  }
};
